import $ from "jquery";
import Cookies from "js-cookie";
import fitvids from "fitvids";
import "lazysizes";
import "slick-carousel";
import "@fancyapps/fancybox";

import directory from "./directory";
import tidal from "./tidal";
import weather from "./weather";
import uiHelpers from "./ui-helpers";
import scriptInViewport from "./script-in-viewport";
import hlsVideo from "./hls-video";
import aos from "./aos"; // animate on scroll replacement
import videoFacade from "./video-facade";

$(".no-js").removeClass("no-js");

hlsVideo.init();
aos.init();
uiHelpers.init();
scriptInViewport();
videoFacade.init();

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Cookies
if (!Cookies.get("EtchCookieConsent")) {
  $("#cookie-message").addClass("cookie-message--visible");
  Cookies.set("EtchCookieConsent", true, { expires: 365 });
}

// Element toggling
$(".js-dropdown").on("click", function() {
  $(".js-dropdown")
    .not(this)
    .next()
    .slideUp(300);
  $(".js-dropdown")
    .not(this)
    .removeClass("active")
    .find(".icon:last-child")
    .removeClass("active");
  $(this)
    .next()
    .slideToggle(300);
  $(this)
    .toggleClass("active")
    .find(".icon:last-child")
    .toggleClass("active");
});

// Navigation
$(".js-nav-toggle").on("click", function(e) {
  const menuItem = $(e.currentTarget);

  if (menuItem.attr("aria-expanded") === "true") {
    $(this).attr("aria-expanded", "false");
  } else {
    $(this).attr("aria-expanded", "true");
  }

  $(this).toggleClass("active");
  $(this)
    .parent()
    .toggleClass("active");

  if ($(this).hasClass("active")) {
    setTimeout(() => {
      $("html, body").addClass("no-scroll");
      $(this)
        .parent()
        .addClass("complete");
    }, 500);
  } else {
    $("html, body").removeClass("no-scroll");
    $(this)
      .parent()
      .removeClass("complete");
  }

  e.preventDefault();
});

// Homepage location map
$(".js-location").on({
  mouseenter() {
    const location = $(this).data("location");
    $(".js-map-marker[data-id='" + location + "']").addClass("shown");
  },
  mouseleave() {
    const location = $(this).data("location");
    $(".js-map-marker[data-id='" + location + "']").removeClass("shown");
  }
});

// Slick
$(".js-fader").slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: false,
  fade: true,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToShow: 1,
  speed: 1200
});

$(".carousel-small-cards").slick({
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 3
});

$(".carousel-center").slick({
  arrows: true,
  centerMode: true,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 3
});

$(".news-events-carousel").slick({
  arrows: true,
  responsive: [
    {
      breakpoint: 980,
      settings: {
        arrows: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 620,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 3
});

$(".webcam-carousel").slick({
  arrows: true,
  asNavFor: ".webcam-carousel-text",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 2
});

$(".webcam-carousel-text").slick({
  arrows: false,
  asNavFor: ".webcam-carousel",
  fade: true,
  slidesToShow: 1
});

// Matching heights on card-based carousels
$(".carousel-outer").each(function() {
  let maxHeight = -1;

  const elementHeights = $(this)
    .find(".content-card__content")
    .map(function() {
      return $(this).outerHeight();
    })
    .get();

  maxHeight = Math.max.apply(null, elementHeights);

  $(this)
    .find(".content-card__content")
    .each(function() {
      $(this).outerHeight(maxHeight);
    });
});

// Scroll to internal anchor links
$(".panel a[href^='#']").on("click", function(e) {
  const a = $(this).attr("href");
  const headerHeight = $(".primary-header").outerHeight();
  $("html,body").animate(
    {
      scrollTop: $(a).offset().top - headerHeight
    },
    300
  );
  e.preventDefault();
});

// Responsive video embeds
fitvids({
  players: "iframe[src*=\"ipcamlive.com\"]"
});

// Weather widget
if ($("#weather-widget").length) {
  weather.init($("#weather-widget"));
}

if ($("#weather-forecast").length) {
  weather.init($("#weather-forecast"));
}

// Tidal widget
if ($("#tidal-widget").length) {
  tidal.init($("#tidal-widget"));
}

// Company Directory filtering
if ($(".js-filter").length) {
  directory.init();
}

// Responsive tables
$(".panel:not(.interaction-panel) table").wrap(
  "<div class=\"table-scroll\"></div>"
);
